import { Element as RawElement } from 'react-scroll';
import { ScrollElementProps } from '../../types';

const ScrollElement = (props: ScrollElementProps) => {
  return <RawElement {...props} />;
};

export default ScrollElement;
